<template>
  <div class="month-report-wrap">
    <handleIcon @allScreen="toggleAllScreenFull(!isAllScreen)" :isAllScreen="isAllScreen">
      <template slot="menu">
        <li @click="() => getAllData()">
          <div class="icon">
            <i class="iconfont iconRefresh"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::refresh') }}</span>
        </li>
      </template>
    </handleIcon>
    <el-row class="card-content">
      <el-col :span="24">
        <cardReport
          :cardData="{ cardItems: cardOptions }"
          @toSetting="outTimeSet"
          v-loading="loading.cardOptions"
        ></cardReport>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <label class="label-item">{{ $t('operate-analysis::month-report::shop_name') }}</label>
        <el-select
          :placeholder="$t('system::common::select_placeholder')"
          :popperAppendToBody="false"
          @change="changeShop"
          filterable
          class="search-item"
          v-model="params.shopId"
        >
          <el-option
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
            v-for="item in shopList"
          ></el-option>
        </el-select>
        <label class="label-item">{{ $t('ocean-bi:订单支付日期') }}</label>
        <el-date-picker
          :appendToBody="false"
          :clearable="false"
          v-model="date"
          @change="handlerDateChange"
          type="daterange"
          unlink-panels
          :range-separator="$t('system::time::text::include')"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :lg="4" :md="24" :sm="24" :xl="4" style="margin-top: 18px">
        <el-row :gutter="16">
          <el-col
            :key="index"
            :lg="24"
            :md="8"
            :sm="8"
            :xl="24"
            class="card-item"
            v-for="(item, index) in logisticsCardOptions"
          >
            <dataCard :option="item" v-loading="loading.logistics" class="my-data-card"></dataCard>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="10" :md="24" :sm="24" :xl="10">
        <reportCard
          @btns="onReportBtns"
          :config="deliverConfig"
          :style="`height: ${reportHeight};`"
          v-loading="loading.deliver"
        ></reportCard>
      </el-col>
      <el-col :lg="10" :md="24" :sm="24" :xl="10">
        <reportCard
          @btns="onReportBtns"
          :config="performConfig"
          :style="`height: ${reportHeight};`"
          v-loading="loading.perform"
        ></reportCard>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :span="24" style="margin-top: 18px" class="order-detail">
        <el-card>
          <div slot="header">
            {{ $t('operate-analysis::order-analysis::订单详情') }}
          </div>
          <z-table
            :columns="columns"
            :data="orderDetailList"
            :height="480"
            :pagination.sync="pagination"
            @page-change="handlePageChange"
            ref="table"
            v-loading="loading.detail"
          >
            <template #product="{ row }">
              <div @click.stop style="position: relative">
                {{ row.product }}
                <GoodsPopover :row="row" :config="params" style="display: inline-block"></GoodsPopover>
              </div>
            </template>
            <template #grandTotalUsd="{ row }">
              {{ $dataCheck(formatNumberMix(row.grandTotalUsd, 2, ',')) }}
            </template>
          </z-table>
        </el-card>
      </el-col>
    </el-row>

    <setting-dialog v-model="showDialog" :drawRow="drawRow" @save="onSave" :form="form"></setting-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/order-card'
import handleIcon from '@/components/handle-icon/index.vue'
import { getShopList, getErpShopList } from '@/server/shopList'
import { getMerchantType, getReportSetting } from '@/server/user'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import cardReport from '@/components/data-analysis/cardReport/cardReport.vue'
import GoodsPopover from './components/goodsPopover.vue'
import { pickerOptions } from '@/utils/datepickerConfig'
import SettingDialog from './components/setting-dialog.vue'
import { toggleAllScreen } from '@/utils/utils'
import {
  getOrderAnalysisOverview,
  getOrderAnalysisLogistics,
  getOrderAnalysisDeliver,
  getOrderAnalysisPerform,
  getOrderAnalysisDetail,
} from '@/server/etl'
export default {
  name: 'order-analysis',
  components: {
    reportCard,
    handleIcon,
    dataCard,
    reportTable,
    cardReport,
    GoodsPopover,
    SettingDialog,
  },
  mixins: [setConfig],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        ...pickerOptions,
      },
      date: [moment().subtract(29, 'day'), moment()],
      params: {
        orgUnitId: this.$store.state.user.merchantId,
        // orgUnitId: 100,
        shopId: undefined,
        startDate: moment().subtract(29, 'day').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      shopList: [{ shopName: this.$t('system::common::select_all_shop'), shopId: undefined }],
      reportHeight: '467px',
      // reportHeight: '357px',
      selectedShop: '', // 选中的站点id
      cardOptions: [],
      logisticsCardOptions: [],
      deliverConfig: {},
      performConfig: {},
      orderDetailList: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      loading: {
        cardOptions: false,
        logistics: false,
        deliver: false,
        perform: false,
        detail: false,
      },
      showDialog: false,
      drawRow: {
        type: '',
        info: {},
      },
      form: {
        outTimeDays: 7,
        performIntervalDays: 7,
        startSetDate: 'pay_to_received_day',
        deliverIntervalDays: 2,
      },
    }
  },
  computed: {
    isAllScreen() {
      return this.$store.state.isAllScreen
    },
    merchantId() {
      return this.$store.state.user.merchantId
    },
  },
  methods: {
    getAllData() {
      this.getOrderOverview()
      this.getLogisticsOverview()
      this.getOrderAnalysisDeliver()
      this.getOrderAnalysisPerform()
      this.getOrderAnalysisDetail()
    },
    changeShop() {
      this.getAllData()
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    },
    async getShopList() {
      const res = await getMerchantType(this.$store.state.user.merchantId)
      if (res.data.code === this.$code) {
        if (res.data.data === 1) {
          const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...((data.data && data.data.items) || [])]
          }
        } else if (res.data.data === 2) {
          const { data } = await getErpShopList(this.merchantId)
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...(data.data || [])]
          }
        }
      }
    },
    async getOrderOverview() {
      this.loading.cardOptions = true
      const { data } = await getOrderAnalysisOverview({ ...this.params, outTimeDays: this.form.outTimeDays })
      this.loading.cardOptions = false
      this.cardOptions = this.setOrderOverview(data.data.datas[0] || {})
    },
    async getLogisticsOverview() {
      this.loading.logistics = true
      const { data } = await getOrderAnalysisLogistics({ ...this.params, outTimeDays: this.form.outTimeDays })
      this.loading.logistics = false
      this.logisticsCardOptions = this.setLogisticsOverview(data.data.datas[0] || {})
    },
    async getOrderAnalysisDeliver() {
      this.loading.deliver = true
      const { data } = await getOrderAnalysisDeliver({ ...this.params, intervalDays: this.form.deliverIntervalDays })
      this.loading.deliver = false
      this.deliverConfig = this.setDeliverConfig((data.data && data.data.datas) || [])
    },
    async getOrderAnalysisPerform() {
      this.loading.perform = true
      const { data } = await getOrderAnalysisPerform({
        ...this.params,
        intervalDays: this.form.performIntervalDays,
        startSetDate: this.form.startSetDate,
      })
      this.loading.perform = false
      this.performConfig = this.setPerformConfig((data.data && data.data.datas) || [])
    },
    async getOrderAnalysisDetail() {
      this.loading.detail = true
      const { data } = await getOrderAnalysisDetail({ ...this.params, ...this.pagination })
      this.loading.detail = false
      this.orderDetailList = data.data.datas
      this.pagination.total = data.data.totalSize
    },
    async getSetting() {
      const { data } = await getReportSetting(0)
      if (data.code === this.$code && data.data.config) {
        console.log(data.data)
        this.form = { ...this.form, ...JSON.parse(data.data.config) }
      }
    },
    toggleAllScreenFull(bool) {
      this.$store.commit('setScreen', bool)
      toggleAllScreen()
    },
    handlePageChange() {
      this.getOrderAnalysisDetail()
    },
    outTimeSet() {
      this.onReportBtns({ type: 'outTime' })
    },
    onReportBtns(info) {
      this.showDialog = true
      this.drawRow.type = info.type
      if (info.type === 'deliver') {
        this.drawRow.info = {
          title: this.$t('operate-analysis::order-analysis::发货时效分布设置'),
        }
      } else if (info.type === 'perform') {
        this.drawRow.info = {
          title: this.$t('operate-analysis::order-analysis::履约时效分布设置'),
        }
      } else if (info.type === 'outTime') {
        this.drawRow.info = {
          title: this.$t('operate-analysis::order-analysis::超时待发货设置'),
        }
      }
    },
    async onSave(type) {
      await this.getSetting()
      if (type === 'deliver') {
        this.getOrderAnalysisDeliver()
      } else if (type === 'perform') {
        this.getOrderAnalysisPerform()
      } else if (type === 'outTime') {
        this.setOrderOverview()
        this.getLogisticsOverview()
      }
    },
  },
  async mounted() {
    this.cardOptions = this.setOrderOverview({})
    this.logisticsCardOptions = this.setLogisticsOverview({})
    await this.getSetting()
    this.getShopList()
    this.getAllData()
  },
}
</script>

<style lang="scss" scoped>
.month-report-wrap {
  position: relative;
  z-index: 8;
}
.control-btn-wrap {
  text-align: right;
  margin-bottom: 8px;
  .item-btn {
    margin-left: 16px;
  }
}
.label-item {
  margin-right: 8px;
}
.search-item {
  margin-right: 16px;
  width: 180px;
}
.day-item {
  width: 204px;
}

.card-content {
  margin-bottom: 16px;
  /deep/ .card-items-report {
    margin-top: 0;
  }
  /deep/ .icon {
    margin-left: 4px;
  }
}
/deep/.el-date-editor .el-range__icon {
  color: #999999;
}
.my-data-card {
  /deep/ .el-card__body {
    padding: 16px 10px;
  }
  @media screen and (min-width: 1300px) and (max-width: 1400px) {
    /deep/ .el-card__body {
      padding: 16px 0px;
    }
  }
}
.order-detail {
  /deep/ .el-card__header {
    border-bottom: 1px solid #dcdfe6;
  }
}
</style>
